import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    formButtonsContainer: {
        width: "100%",
        textAlign: "right",
        "& > button": {
            marginLeft: theme.spacing(0.5),
        },
    },
    avatarForm: {
        width: theme.spacing(30),
        height: theme.spacing(30),
    },
    avatarEditorIcon: {
        position: "absolute",
    },
    avatarSettingRoot: {
        display: "inline-flex",
    },
}));
export default useStyles;
